<!-- desktop template -->
<div *appIsDesktop>
  @if (isLoading || isUploading) {
    <div class="overlay full" id="quote-mobile-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      @if (isLoading) {
        <mat-spinner></mat-spinner>
      }
    </div>
  }
  <div id="productsSection" class="products content">
    <div class="margin-bottom actions-container">
      <div class="search-container">
        <app-grid-product-search (toolSelected)="addNewTool($event)"
          [disabled]="!canEdit || quoteSaveInProgress || electronAppOutOfSync || disableExcelUpload"
          [countryCodeId]="countryCodeId">
        </app-grid-product-search>
      </div>

      <div class="line-container">
        <div class="checkbox-container" id="gridOptionsContainer">
          <typography class="label" variant="caption-2" weight="bold" id="viewLabel"> {{ appStrings.button_view }}: </typography>
          @if (displayCheckboxOEMsku) {
            <ds-checkbox class="check" [label]="appStrings.products_gridOemSku" (change)="toggleOemSku()" id="showOemSkuCheckbox"
              [control]="checkboxForm.controls.showOemSku" [isDisabled]="!canEdit || quoteSaveInProgress">
            </ds-checkbox>
          }
          <ds-checkbox class="check" [label]="appStrings.products_gridATP" (change)="toggleAtp()" id="atpCheckbox"
            [control]="checkboxForm.controls.atpChecked" [isDisabled]="!canEdit || quoteSaveInProgress">
          </ds-checkbox>
        </div>
        <ds-divider [vertical]="true"></ds-divider>
        <div class="button-container">
          <ds-menu id="addMultipleItemsMenu" (onClick)="onMenuClick($event)" (click)="setMenuItems()" iconStyle="material-icons-outlined" icon="left-icon" [menuOptions]="menuItems" menu_description="bottom"
            dsButtonIcon="library_add" dsButtonSize="medium" dsButtonType="secondary" dsButtonVariant="label-icon" dsButtonIconStyle="material-icons-outlined" [dsButtonLabel]="appStrings.quote_addMultipleItems"
            [dsButtonDisabled]="!cwLoaded.productList || !cwLoaded.whList || !canEdit || quoteSaveInProgress || itemizeInProgress">
          </ds-menu>
          <ds-button id="renumberButton" icon="format_list_numbered" size="medium" type="secondary" variant="label-icon" iconStyle="material-icons-outlined" [label]="appStrings.button_renumberItemList"
            (onClick)="renumberItemList()" [isDisabled]="!totalRecords || !canEdit || quoteSaveInProgress || electronAppOutOfSync">
          </ds-button>
        </div>
      </div>
    </div>

    <div class="products-list">
      <ds-table mat-table matSort [isExpandable]="true" id="productListTable" (matSortChange)="sortData($event)" [dataSource]="recordList" [displayedColumns]="displayedColumns">
        <ng-template dsExpandedRow let-element>
          @if (element.productNumber) {
            <app-product-row-detail [element]="element"></app-product-row-detail>
          }
        </ng-template>
        
        <ng-container matColumnDef="lineNumber">
          <th mat-header-cell *matHeaderCellDef id="productGridLineNumberLabel"> {{ appStrings.products_gridLineNumber }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridLineNumber-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (element.editable && isExistingProductRow(i)) {
              <ds-textfield id="lineNumberEditInput"
                class="no-subscript line-number-input" [control]="currentRow.controls.lineNumber" [isDisabled]="!canEdit || quoteSaveInProgress"
                appNumericInput [maxDigits]="5" (keydown)="onInputKeyDown($event, false)">
              </ds-textfield>
            } @else {
              {{ element.lineNumber }}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="customTool">
          <th mat-header-cell *matHeaderCellDef id="customCheckboxLabel"> {{ appStrings.products_customCheckbox }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'customCheckbox-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (isExistingProductRow(i)) {
              <ds-checkbox [id]="'customCheckbox-'+i" [checked]="element.customTool"
                (change)="openCustomTool(element)" [isDisabled]="!canEdit || quoteSaveInProgress">
              </ds-checkbox>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="partNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="productGridPartNumberLabel"> {{ appStrings.products_gridPartNumber }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridPartNumber-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (isNewProductRow(i)) {
              <ds-textfield id="partNumberNewInput" class="no-subscript part-number-input"
                [control]="newProductRow.controls.productNumber" [isDisabled]="!canEdit || quoteSaveInProgress || disableExcelUpload"
                (keydown)="onInputKeyDown($event, true)">
              </ds-textfield>
            }
            @if (element.editable && isExistingProductRow(i)) {
              <ds-textfield id="partNumberEditInput"
                class="no-subscript part-number-input" [control]="currentRow.controls.productNumber" [isDisabled]="!canEdit || quoteSaveInProgress"
                (keydown)="onInputKeyDown($event, false)">
              </ds-textfield>
            }
            @if (!element.editable && isExistingProductRow(i)) {
              <span>{{ element.productNumber }}</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="oemSku">
          <th mat-header-cell *matHeaderCellDef id="oemSkuLabel" [style.display]="checkboxForm.controls.showOemSku.value ? '' : 'none'">
            {{ appStrings.products_gridOemSku }}
          </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'oemSku-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)"
            [style.display]="checkboxForm.controls.showOemSku.value ? '' : 'none'">
            @if (isExistingProductRow(i)) {
              <span>{{ element.oemSku }}</span>
            }
            @if (isNewProductRow(i)) {
              <span> - </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef id="productGridDescriptionLabel"> {{ appStrings.products_gridDescription }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridDescription-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (isNewProductRow(i)) {
              <ds-textfield id="descriptionNewInput" class="no-subscript"
                [control]="newProductRow.controls.description" [isDisabled]="!canEdit || quoteSaveInProgress"
                (keydown)="onInputKeyDown($event, true)">
              </ds-textfield>
            }
            @if (element.editable && isExistingProductRow(i)) {
              <ds-textfield id="descriptionEditInput" class="no-subscript"
                [control]="currentRow.controls.description" [isDisabled]="!canEdit || quoteSaveInProgress"
                (keydown)="onInputKeyDown($event, false)">
              </ds-textfield>
            }
            @if (!element.editable && isExistingProductRow(i)) {
              <span>{{ element.description }}</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef id="productGridQuantityLabel"> {{ appStrings.products_gridQuantity }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridQuantity-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (isNewProductRow(i)) {
              <ds-textfield id="quantityNewInput" class="no-subscript quantity-input"
                [control]="newProductRow.controls.quantity" [isDisabled]="!canEdit || quoteSaveInProgress"
                appNumericInput [maxDigits]="5" (keydown)="onInputKeyDown($event, true)">
              </ds-textfield>
            }
            @if (element.editable && isExistingProductRow(i)) {
              <ds-textfield id="quantityEditInput" class="no-subscript quantity-input"
                [control]="currentRow.controls.quantity" [isDisabled]="!canEdit || quoteSaveInProgress"
                appNumericInput [maxDigits]="5" (keydown)="onInputKeyDown($event, false)">
              </ds-textfield>
            }
            @if (!element.editable && isExistingProductRow(i)) {
              <span>{{ element.quantity }}</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="countryOfOrigin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="productGridCountryOfOriginLabel"> {{ appStrings.products_gridCountryOfOrigin }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridCountryOfOrigin-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            <span>{{ element.countryOfOrigin ?? '-'}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="listPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="productGridListPriceLabel"> {{ appStrings.products_gridListPrice }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridListPrice-'+i" class="no-break"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (isExistingProductRow(i) && element.listPrice) {
              <span>
                {{ element.listPrice | currency: currencySymbol }}
              </span>
            } @else {
              <ng-template [ngTemplateOutlet]="isExistingProductRow(i) && (element.hasExpiredPricing ? notApplicable : noPrice)"></ng-template>
            }
            @if (isNewProductRow(i)) {
              <span> - </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="netPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="productGridNetPriceLabel"> {{ appStrings.products_gridNetPrice }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridNetPrice-'+i" class="no-break"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (isNewProductRow(i)) {
              <ds-textfield id="netPriceNewInput" class="no-subscript net-price-input"
                [control]="newProductRow.controls.netPrice" [isDisabled]="!canEdit || quoteSaveInProgress"
                (keydown)="onInputKeyDown($event, true)">
              </ds-textfield>
            }
            @if (element.editable && isExistingProductRow(i)) {
              <ds-textfield id="netPriceEditInput" class="no-subscript net-price-input"
                [control]="currentRow.controls.netPrice" [isDisabled]="!canEdit || quoteSaveInProgress"
                (keydown)="onInputKeyDown($event, false)">
              </ds-textfield>
            }
            @if (!element.editable && isExistingProductRow(i)) {
              <span>
                @if (element.netPrice) {
                  {{ element.netPrice | currency: currencySymbol }}
                } @else {
                  <ng-template [ngTemplateOutlet]="element.hasExpiredPricing ? notApplicable : noPrice"></ng-template>
                }
              </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="totalPrice">
          <th mat-header-cell *matHeaderCellDef id="productGridTotalPriceLabel"> {{ appStrings.products_gridTotalPrice }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridTotalPrice-'+i" class="no-break"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (isExistingProductRow(i) && !element.hasExpiredPricing) {
              <span>
                {{ element.total | currency: currencySymbol }}
              </span>
            } @else {
              <ng-template [ngTemplateOutlet]="isExistingProductRow(i) && notApplicable"></ng-template>
            }
            @if (isNewProductRow(i)) {
              <span> - </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="atp">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="productGridAtpLabel" [style.display]="checkboxForm.controls.atpChecked.value ? '' : 'none'">
            {{ appStrings.products_gridATP }}
            <span (click)="$event.stopPropagation(); $event.preventDefault()">
              <app-atp-button [disabled]="!checkboxForm.controls.atpChecked.value || !cwLoaded.productList || !cwLoaded.whList || !canEdit || quoteSaveInProgress || itemizeInProgress">
              </app-atp-button>
            </span>
          </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridAtp-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)"
            [style.display]="checkboxForm.controls.atpChecked.value ? '' : 'none'">
            @if (element.estimatedShipDate) {
              <ds-button class="link" size="medium" type="tertiary"
                variant="label-only" label="{{ element.estimatedShipDate | date: dateFormat }}" (onClick)="openATPPop(element)">
              </ds-button>
            } @else {
              <ng-template [ngTemplateOutlet]="isExistingProductRow(i) && tbd"></ng-template>
            }
            <ng-template #tbd>{{ appStrings.tbd }}</ng-template>
            @if (isNewProductRow(i)) {
              <span> - </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="lineWeight">
          <th mat-header-cell *matHeaderCellDef id="productGridLineWeightLabel"> {{ appStrings.products_gridLineWeight }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridLineWeight-'+i" class="no-break"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}"
            (click)="isExistingProductRow(i) && onRowClick(element, $event, i)">
            @if (element.lineWeight) {
              <span>
                {{ roundWeight(element.lineWeight) }} {{ weightSymbol }}
              </span>
            }
            @if (isNewProductRow(i)) {
              <span> - </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="notifications">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="productGridLineNotificationsLabel"> {{ appStrings.products_gridNotifications }} </th>
          <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'productGridLineNotifications-'+i"
            [ngClass]="{'loading-overlay': element.isLoading, 'warn': warnForErrors && element.hasError}">
            <div class="actions-cell" (click)="$event.stopPropagation()">
              @if (isExistingProductRow(i) && element.notificationIcon) {
                <ds-button [id]="'notification-button_' + i" size="medium" type="tertiary"
                  [ngClass]="['notification-button', element.notificationIcon]" variant="icon-only" [icon]="element.notificationIcon"
                  [isDisabled]="quoteSaveInProgress || itemizeInProgress || element.isLoading"
                  [matMenuTriggerFor]="notificationMenu" (click)="!element.isLoading && !itemizeInProgress && showNotifications(element, i, $event)"
                  iconStyle="material-icons">
                </ds-button>
              }
              @if (isExistingProductRow(i) && !element.notificationIcon) {
                <span class="no-notification"></span>
              }
              <ds-button [id]="'notes-button_' + i" size="medium" type="tertiary" variant="icon-only"
                [icon]="element.lineNotes?.notes?.length ? 'assignment_turned_in' : 'article'" class="notes-button"
                [isDisabled]="quoteSaveInProgress || itemizeInProgress || element.isLoading" (onClick)="openNotesDialog(element, $event)"
                iconStyle="material-icons-outlined" [ngClass]="{'green-icon': element.lineNotes?.notes?.length}">
              </ds-button>
              @if (isExistingProductRow(i)) {
                <ds-button [id]="'delete-button_' + i" size="medium" type="tertiary" variant="icon-only" icon="delete"
                  [isDisabled]="!canEdit || element.isLoading || quoteSaveInProgress || itemizeInProgress"
                  (onClick)="deleteTool(element, $event)" iconStyle="material-icons-outlined">
                </ds-button>
              }
              @if (isNewProductRow(i)) {
                <ds-button id="add-button" class="add-btn" size="medium" type="secondary" variant="label-only"
                  [isDisabled]="!newProductRow.controls.productNumber || !newProductRow.controls.quantity || disableExcelUpload || !canEdit || quoteSaveInProgress"
                  (onClick)="addNewToolFromRow()" [label]="appStrings.button_add">
                </ds-button>
              }
            </div>
          </td>
        </ng-container>
      </ds-table>
    </div>

    <div class="bottom-actions-container">
      @if (totalPages > 1) {
        <div class="pagination-container">
          <div class="pagination">
            <ds-pagination
              [totalPages]="totalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          </div>
        </div>
      }
      <ds-button size="medium" type="secondary" variant="label-only" [label]="appStrings.button_continue" id="continueButton" (onClick)="continue()">
      </ds-button>
    </div>
  </div>
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  <div class="search-container">
    <app-grid-product-search (toolSelected)="addNewTool($event)"
      [disabled]="!canEdit || quoteSaveInProgress || disableExcelUpload"
      [countryCodeId]="countryCodeId">
    </app-grid-product-search>
  </div>

  @if (isLoading) {
    <div class="overlay full" id="quote-mobile-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      @if (isLoading) {
        <mat-spinner></mat-spinner>
      }
    </div>
  }

  <div class="checkbox-container">
    <typography class="label" variant="caption-2" weight="bold"> {{ appStrings.button_view }}: </typography>
    @if (displayCheckboxOEMsku) {
      <ds-checkbox [label]="appStrings.products_gridOemSku" (change)="toggleOemSku()" id="showOemSkuCheckbox"
        [control]="checkboxForm.controls.showOemSku" [isDisabled]="!canEdit || quoteSaveInProgress">
      </ds-checkbox>
    }
    <ds-checkbox [label]="appStrings.products_gridATP" (change)="toggleAtp()" id="atpCheckbox"
      [control]="checkboxForm.controls.atpChecked" [isDisabled]="!canEdit || quoteSaveInProgress">
    </ds-checkbox>
  </div>

  <div class="button-container">
    <ds-menu (onClick)="onMenuClick($event)" (click)="setMenuItems()" iconStyle="material-icons-outlined" icon="left-icon" [menuOptions]="menuItems" menu_description="bottom"
      dsButtonIcon="library_add" dsButtonSize="medium" dsButtonType="secondary" dsButtonVariant="icon-only" dsButtonIconStyle="material-icons-outlined"
      [dsButtonDisabled]="!cwLoaded.productList || !cwLoaded.whList || !canEdit || quoteSaveInProgress || itemizeInProgress">
    </ds-menu>
    <app-atp-button
      [disabled]="!checkboxForm.controls.atpChecked.value || !cwLoaded.productList || !cwLoaded.whList || !canEdit || quoteSaveInProgress || itemizeInProgress">
    </app-atp-button>
    <ds-divider [vertical]="true"></ds-divider>
    <ds-button class="add-item-button" size="medium" type="secondary" variant="label-only" [label]="appStrings.products_gridAddProduct"
      [isDisabled]="!canEdit || quoteSaveInProgress || itemizeInProgress" (onClick)="addItem()">
    </ds-button>
  </div>

  <div class="product-container">
    <!-- skip first empty item for mobile -->
    @for (item of ((recordList | async) || []).slice(1); track item; let i = $index) {
      <mat-expansion-panel class="mobile-card product permanent header-columns grey blue-border panel-relative">
        <mat-expansion-panel-header [id]="'productCardHeader_'+i" class="content-header">
          @if (item.isLoading) {
            <div class="panel-loading-overlay">
              <mat-spinner class="small"></mat-spinner>
            </div>
          }
          <mat-panel-title class="mobile-panel-title" [id]="'productContent_'+i">
            <div class="title-row">
              <span [id]="'product-title_'+i" class="title">
                #{{ item.lineNumber }} - {{ item.productNumber }}
              </span>
            </div>
            <div class="details-row">
              <div class="row">
                <div class="column one-forth">
                  <typography [id]="'quantity_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridQuantity }} </typography>
                  <typography [id]="'quantity_'+i" variant="body-2" weight="medium"> {{ item.quantity }} </typography>
                </div>
                <div class="column three-forths">
                  <typography [id]="'description_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridDescription }} </typography>
                  <typography [id]="'description_'+i" variant="body-2" weight="medium"> {{ item.description || '-' }} </typography>
                </div>
              </div>
              <div class="row hidden-details-row">
                @if (checkboxForm.controls.atpChecked.value) {
                  <div class="column one-third">
                    <typography [id]="'listPrice_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridATP }} </typography>
                    @if (item.estimatedShipDate) {
                      <ds-button [id]="'atp_'+i" class="link" size="medium" type="tertiary" variant="label-only" label="{{ item.estimatedShipDate | date: dateFormat }}"
                        (onClick)="openATPPop(item, $event)">
                      </ds-button>
                    }
                    @if (!item.estimatedShipDate) {
                      <typography [id]="'atp_'+i" variant="body-2" weight="medium"> {{ appStrings.tbd }} </typography>
                    }
                  </div>
                }
                <div class="column one-third">
                  <typography [id]="'unitNetPrice_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridCountryOfOrigin }} </typography>
                  <typography [id]="'unitNetPrice_'+i" variant="body-2" weight="medium"> {{ item.countryOfOrigin || '-' }} </typography>
                </div>
                <div class="column one-third">
                  <typography [id]="'lineTotal_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridLineWeight }} </typography>
                  <typography [id]="'lineTotal_'+i" variant="body-2" weight="medium"> {{ roundWeight(item.lineWeight) }} {{ weightSymbol }} </typography>
                </div>
              </div>
              <div class="row hidden-details-row">
                @if (checkboxForm.controls.showOemSku.value) {
                  <div class="column one-third">
                    <typography [id]="'oemSku_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridOemSku }} </typography>
                    <typography [id]="'oemSku_'+i" variant="body-2" weight="medium"> {{ item.oemSku || '-'}} </typography>
                  </div>
                }
              </div>
              <div class="row">
                <div class="column one-third">
                  <typography [id]="'listPrice_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridListPrice }} </typography>
                  <typography [id]="'listPrice_'+i" variant="body-2" weight="medium"> {{ item.listPrice | currency: currencySymbol }} </typography>
                </div>
                <div class="column one-third">
                  <typography [id]="'unitNetPrice_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridNetPrice }} </typography>
                  <typography [id]="'unitNetPrice_'+i" variant="body-2" weight="medium"> {{ item.netPrice | currency: currencySymbol }} </typography>
                </div>
                <div class="column one-third">
                  <typography [id]="'lineTotal_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.products_gridTotalPrice }} </typography>
                  <typography [id]="'lineTotal_'+i" variant="body-2" weight="medium"> {{ item.total | currency: currencySymbol }} </typography>
                </div>
              </div>
              <div class="row hidden-details-row">
                <div class="column">
                  @if (!isLead) {
                    <ds-checkbox (change)="openCustomTool(item)" [label]="appStrings.products_customCheckbox" id="customToolItemCheckbox"
                      [checked]="item.customTool" [isDisabled]="!canEdit || quoteSaveInProgress">
                    </ds-checkbox>
                  }
                </div>
              </div>
              <ds-divider></ds-divider>
              <div class="button-container padded">
                @if (item.notificationIcon) {
                  <ds-button size="small" type="tertiary" [ngClass]="['notification-button', item.notificationIcon]"
                    variant="label-icon" [icon]="item.notificationIcon" [label]="appStrings.products_gridNotifications"
                    [isDisabled]="quoteSaveInProgress || itemizeInProgress" [matMenuTriggerFor]="notificationMenu"
                    (click)="!item.isLoading && !itemizeInProgress && showNotifications(item, i, $event)" iconStyle="material-icons">
                  </ds-button>
                }
                <ds-button size="small" type="tertiary" variant="label-icon" [icon]="item.lineNotes?.notes?.length ? 'assignment_turned_in' : 'article'"
                  [label]="appStrings.products_gridNotes" class="notes-button" [isDisabled]="quoteSaveInProgress || itemizeInProgress"
                  (onClick)="openNotesDialog(item, $event)" iconStyle="material-icons-outlined" [ngClass]="{'green-icon': item.lineNotes?.notes?.length}">
                </ds-button>
                <ds-button size="small" type="tertiary" variant="label-icon" icon="edit" [label]="appStrings.button_edit"
                  [isDisabled]="!canEdit || quoteSaveInProgress || itemizeInProgress" (onClick)="editItem(item, $event)" iconStyle="material-icons-outlined">
                </ds-button>
                <ds-button size="small" type="tertiary" variant="label-icon" icon="delete" [label]="appStrings.button_delete"
                  [isDisabled]="!canEdit || quoteSaveInProgress || itemizeInProgress" (onClick)="deleteTool(item, $event)" iconStyle="material-icons-outlined">
                </ds-button>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="panel-content">
        </div>
      </mat-expansion-panel>
    }
  </div>

  @if (totalPages > 1) {
    <div class="pagination-container">
      <div class="pagination">
        <ds-pagination
          [totalPages]="totalPages"
          paginationDisplay="small"
          buttonTypes="nextPrevFirstLast"
          (pageChanged)="loadPage($event)"
        ></ds-pagination>
      </div>
    </div>
  }

  <div class="continue-button-container">
    <ds-button size="medium" type="secondary" variant="label-only" [label]="appStrings.button_continue" id="continueButton" (onClick)="continue()">
    </ds-button>
  </div>
</div>

<!-- common -->
<input #fileUploadControl id="productsUploadExcelHidden" type="file" accept=".xlsx;*.xls"
  (change)="uploadExcel($event)" name="uploadExcelButton" class="hidden" />

  <mat-menu #notificationMenu="matMenu" class="tool-notifications-container" xPosition="before">
    <app-tooltip-notification (buttonCallback)="tooltipCallback($event)"
    [canEdit]="canEdit && !quoteSaveInProgress"></app-tooltip-notification>
  </mat-menu>

  <ng-template #noPrice>
    {{ 0 | currency: currencySymbol }}
  </ng-template>

  <ng-template #notApplicable>
    N/A
  </ng-template>

  <ds-dialog
    [title]="dialogTitle"
    [description]="dialogText"
    [actionButtons]="dialogButtons"
    [disableClose]="dialogDisableClose"
    [open]="dialogOpen$">
  </ds-dialog>

